document.addEventListener('DOMContentLoaded', function() {
  const offerWidget = document.querySelector('.nw-offer');
  
  if (!offerWidget) return;
  
  const bundleRadios = offerWidget.querySelectorAll('input[name="nw-offer-bundle"]');
  const purchaseTypeRadios = offerWidget.querySelectorAll('input[name="purchase_type"]');
  const subscriptionPrice = offerWidget.querySelector('.nw-offer__block-subscription-block--subscription .nw-offer__block-subscription-block-header-price');
  const onetimePrice = offerWidget.querySelector('.nw-offer__block-subscription-block--onetime .nw-offer__block-subscription-block-header-price');
  const ctaButton = offerWidget.querySelector('[data-offer-cta]');
  
  // Function to update prices and URL
  function updateOfferDetails() {
    // Get selected bundle
    const selectedBundle = offerWidget.querySelector('input[name="nw-offer-bundle"]:checked');
    
    if (!selectedBundle) return;
    
    // Get bundle data
    const bundlePrice = selectedBundle.dataset.price;
    const bundleStrikePrice = selectedBundle.dataset.strikePrice;
    const subscriptionUrl = selectedBundle.dataset.subscriptionUrl;
    const onetimeUrl = selectedBundle.dataset.onetimeUrl;
    
    // Update prices in subscription and onetime widgets
    if (subscriptionPrice) {
      subscriptionPrice.textContent = bundlePrice;
    }
    
    if (onetimePrice) {
      onetimePrice.textContent = bundleStrikePrice;
    }
    
    // Get selected purchase type
    const selectedPurchaseType = offerWidget.querySelector('input[name="purchase_type"]:checked');
    
    if (!selectedPurchaseType) return;
    
    // Update CTA button URL based on purchase type
    if (ctaButton) {
      if (selectedPurchaseType.value === 'subscription') {
        ctaButton.href = subscriptionUrl;
      } else if (selectedPurchaseType.value === 'onetime') {
        ctaButton.href = onetimeUrl;
      }
    }
  }
  
  // Add change event listeners to bundle radios
  bundleRadios.forEach(function(radio) {
    radio.addEventListener('change', updateOfferDetails);
  });
  
  // Add change event listeners to purchase type radios
  purchaseTypeRadios.forEach(function(radio) {
    radio.addEventListener('change', updateOfferDetails);
  });
  
  // Initialize on page load
  updateOfferDetails();
});

